module.exports = __webpack_public_path__ + "static/media/feishu_serve.c0776e2f.png";